import { mcGetItem, mcSetItem } from './mcCloudSync';

export const MC_ACTIVITY_KEY = 'mc-operational-activity-v1';
export const MC_ACTIVITY_EVENT = 'mc-operational-activity-change';

function safeParse(raw, fallback = []) { try { return raw ? JSON.parse(raw) : fallback; } catch (_) { return fallback; } }
function clean(value = '') { return String(value || '').trim(); }
function currentActor() {
  let profile = null;
  try { profile = safeParse(window?.sessionStorage?.getItem('mc-current-profile-session'), null); } catch (_) {}
  if (!profile) profile = safeParse(mcGetItem('mc-current-profile'), null);
  const name = clean([profile?.name, profile?.surname].filter(Boolean).join(' ')) || clean(profile?.email) || 'System';
  return { personId: profile?.id || '', person: name, role: profile?.operationalRole || profile?.accessLevel || profile?.role || '' };
}
export function loadActivityEvents() {
  const value = safeParse(mcGetItem(MC_ACTIVITY_KEY), []);
  return Array.isArray(value) ? value.filter(Boolean) : [];
}
export function recordActivity(input = {}) {
  if (typeof window === 'undefined') return null;
  const actor = currentActor();
  const timestamp = input.timestamp || new Date().toISOString();
  const event = {
    id: input.id || `mc-activity-${Date.now()}-${Math.random().toString(36).slice(2,8)}`,
    timestamp,
    personId: input.personId ?? actor.personId,
    person: input.person || actor.person,
    role: input.role || actor.role,
    category: input.category || 'Operations',
    action: input.action || 'Updated',
    title: input.title || input.action || 'Operational event',
    description: input.description || '',
    site: input.site || 'All Sites',
    severity: input.severity || 'normal',
    source: input.source || 'Morpheus',
    targetId: input.targetId || '',
    targetName: input.targetName || '',
    metadata: input.metadata || {},
  };
  const next = [event, ...loadActivityEvents()].slice(0, 2500);
  const raw = JSON.stringify(next);
  // mcSetItem already feeds Morpheus' coalescing Firestore write bridge.
  // Do not also call mcSetCloudItem here: that second path wrote the same growing
  // activity document immediately for every event, defeating key-level batching
  // and doubling cloud traffic during bursty work such as global distribution.
  // Synchronous activity bursts now collapse to the latest document value before
  // the background writer commits it.
  mcSetItem(MC_ACTIVITY_KEY, raw);
  try { window.dispatchEvent(new CustomEvent(MC_ACTIVITY_EVENT, { detail: event })); } catch (_) {}
  return event;
}
export function recordActivityChange({ category='Administration', action='Updated', title, description='', site='All Sites', targetId='', targetName='', before=null, after=null, metadata={} } = {}) {
  return recordActivity({ category, action, title: title || action, description, site, targetId, targetName, metadata: { ...metadata, before, after } });
}
